import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/inversum/src/components/Header.tsx");
